import { useState } from 'react';
import './LoginPage.css';

const API_URL = 'https://sadaqa25api.ssfkerala.org/auth/login.php';

export default function LoginPage({ onSuccess }) {
  const [loginName, setLoginName] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (!loginName.trim() || !password) {
      setError('Enter login name and password');
      return;
    }

    setSubmitting(true);
    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          login_name: loginName.trim(),
          password,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Login failed');
      }

      onSuccess(data);
    } catch (err) {
      setError(err.message || 'Unable to login');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-hero">
        <span className="login-badge">Sadaqa Fund Analysis</span>
      </div>

      <div className="login-card">
        <div className="login-card-header">
          <h2>Sign in</h2>
          <p>
          Use the same username and password as{' '}
          <a href="https://portal.ssfkerala.org" target="_blank" rel="noopener noreferrer">
            portal.ssfkerala.org
          </a>
        </p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <label className="login-label" htmlFor="loginName">
            Username
          </label>
          <input
            id="loginName"
            className="login-input"
            type="text"
            value={loginName}
            autoComplete="username"
            placeholder="Enter SSF credentials"
            onChange={(event) => setLoginName(event.target.value)}
            disabled={submitting}
          />

          <label className="login-label" htmlFor="password">
            Password
          </label>
          <input
            id="password"
            className="login-input"
            type="password"
            value={password}
            autoComplete="current-password"
            placeholder="Enter password"
            onChange={(event) => setPassword(event.target.value)}
            disabled={submitting}
          />

          {error && <div className="login-error">{error}</div>}

          <button className="login-button" type="submit" disabled={submitting}>
            {submitting ? 'Signing in…' : 'Access dashboard'}
          </button>
        </form>
      </div>
    </div>
  );
}
